import { listEventTimeSlots } from '../../api/listEventTimeSlots/listEventTimeSlots';
import { InitiatorsArgs } from '../initWidgetData';
import type { IHttpError } from '@wix/http-client';
import { AsyncComponentDataStatus } from '../../../components/DailyAgenda/state/types';
import { TriggeredByOptions } from '../../../utils/bi/consts';
import settingsParams from '../../../components/DailyAgenda/settingsParams';

export const initSlots = async (
  args: InitiatorsArgs,
  triggeredBy: TriggeredByOptions,
) => {
  const { flowAPI, setState, getState, biLogger } = args;
  const { selectedFilters, selectedDate, selectedTimezone } = getState();
  const scrollBetweenDays = flowAPI.settings.get(
    settingsParams.scrollBetweenDays,
  );
  try {
    const { timeSlots, pagingMetadata } = await listEventTimeSlots({
      range: {
        from: selectedDate,
        to: !scrollBetweenDays ? selectedDate : undefined,
      },
      flowAPI,
      filters: selectedFilters,
      timeZone: selectedTimezone,
    });

    if (!timeSlots) {
      setState({
        slots: {
          status: AsyncComponentDataStatus.ERROR,
          data: 'No slots found',
        },
        slotsMetaData: {
          status: AsyncComponentDataStatus.ERROR,
          data: 'No slots found',
        },
      });
      return;
    }

    setState({
      slots: {
        status: AsyncComponentDataStatus.IDLE,
        data: timeSlots,
      },
      slotsMetaData: {
        status: AsyncComponentDataStatus.IDLE,
        data: pagingMetadata,
      },
    });
    biLogger?.reportSessionsLoaded(triggeredBy, selectedDate, timeSlots);
  } catch (error) {
    setState({
      slots: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
      slotsMetaData: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
    });
    console.error('Error initializing slots:', error);
  }
};
